import React, { useRef } from "react";
import Select from "react-select";
import { Stack } from "@mui/system";
import clsx from "clsx";

function Dropdown(props) {
  const selectInputRef = useRef();
  console.log("FBprops", props);

  const onClear = () => {
    console.log("selectInputRef", selectInputRef);
    selectInputRef.current.clearValue();
  };
  let customStyles = {
    option: (styles) => {
      return {
        ...styles,
        // backgroundColor: "#232135",
        color: "#fff",
        borderColor: "#4D5369;",
      };
    },

    valueContainer: (styles) => {
      return { ...styles, backgroundColor: "#141623", color: "#fff" };
    },
    control: (styles) => {
      return {
        ...styles,
        backgroundColor: "#141623",
        borderColor: "#4D5369;",
        overflowY: "auto",
        height: "30px",
      };
    },
    singleValue: (styles) => {
      return {
        ...styles,
        color: "#fff",
        fontSize: "12px",
      };
    },
    dropdownIndicator: (styles) => {
      return { ...styles, backgroundColor: "#141623", borderColor: "#313131" };
    },
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: "#e6e6e6",
        borderColor: "#313131",
        color: "#000",
        fontSize: "12px",
        fontFamily: "Eurostile Extended",
        fontWeight: "100",
      };
    },
    multiValueRemove: (styles) => {
      return { ...styles, backgroundColor: "#e6e6e6", color: "#000" };
    },
    multiValueLabel: (styles) => {
      return {
        ...styles,
        color: "#000",
        fontFamily: "Eurostile",
        fontSize: "13",
        height: "25",
      };
    },
    indicatorsContainer: (styles) => {
      return {
        ...styles,
        backgroundColor: "#141623",
        borderColor: "#313131",
        position: " absolute",
        right: "0px",
        fontSize: "12px",
        fontFamily: "Eurostile Extended",
      };
    },
    indicatorSeparator: (styles) => {
      return { ...styles, display: "none" };
    },
    clearIndicator: (styles) => {
      return { ...styles, backgroundColor: "#0d0d17", borderColor: "#313131" };
    },
    placeholder: (styles) => {
      return {
        ...styles,
        color: "#636973",
        fontSize: "12px",
        fontFamily: "Eurostile Extended",
      };
    },
    menu: (styles) => {
      return {
        ...styles,
        margin: 0,
        background: "#141623",
        fontSize: "12px",
        fontFamily: "Eurostile Extended",
      };
    },
    SelectContainer: (styles) => {
      return {
        ...styles,
        margin: 0,
        background: "#000",
        fontSize: "12px",
        fontFamily: "Eurostile Extended",
      };
    },
    selectOption: (styles) => {
      return {
        ...styles,
        margin: 0,
        background: "#fff",
        fontSize: "12px",
        fontFamily: "Eurostile Extended",
      };
    },
    input: (styles) => {
      return {
        ...styles,
        color: "#ffffff",
        fontFamily: "Eurostile",
        fontSize: "13",
        height: "25",
      };
    },
  };
  return (
    <>
      <Select
        ref={selectInputRef}
        options={props.options}
        placeholder={props.placeholder}
        value={props.value}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          opacity: 2,
          colors: {
            ...theme.colors,
            primary25: "#5d5c68",
            primary: "black",
          },
        })}
        defaultValue={props.defaultValue}
        closeMenuOnSelect={props.closeMenuOnSelect === false ? false : true}
        hideSelectedOptions={false}
        components={props.components}
        styles={customStyles}
        onChange={props.onChange}
        allowSelectAll={true}
        isSearchable={props.isSearchable === false ? false : true}
        isMulti={props.isMulti === true ? true : false}
        isDisabled={props?.isDisabled === true ? true : false}
        //isClearable
      />

      <Stack className="cleartext" onClick={onClear} id={props.clearID}>
        Clear
      </Stack>
    </>
  );
}

export default Dropdown;
